<template>
    <div class="page3">
        <b-modal id="confirm-next" ref="confirm-next"  hide-footer centered>
            <template #modal-title>
                <h6>Xác nhận</h6>
            </template>
            <div class="d-block text-center">
                <div class="alert alert-warning" role="alert">
                    <p class="mb-1">Bạn có chắc chắn muốn chuyển qua phần tiếp theo không?</p>
                    <p class="">khi chuyển sang phần tiếp theo bạn không thể quay lại phần thi trước</p>
                </div>
                <!-- <div class="alert alert-warning" role="alert">
                    <p class="mb-1">Bạn chắc chắn muốn nộp bài không?</p>
                    <p class="">Khi đã nộp bài, bạn sẽ không thể chỉnh sửa câu trả lời của mình nữa.</p>
                </div> -->
                <div>
                    <b-button class="mx-3" variant="secondary" block @click="$bvModal.hide('confirm-next')">Hủy</b-button>
                    <b-button  class="mx-3 " variant="primary" block @click="clearEditorContent(); $bvModal.hide('confirm-next')">Xác nhận</b-button>

                    </div>
            </div>
        </b-modal>
        <b-modal id="check_character" ref="check_character"  hide-footer centered>
             <div class="text-center">
                Bài làm của bạn phải ít nhất 50 ký tự thì mới có thể nộp bài .
             </div>
        </b-modal>
        <div class="time-box-sticky" id="time-box-sticky" :class="toggleNavClass()">
            <div>
                <div class="box_title">{{ this.partTitle }}</div>
            </div>
            <div class="d-flex align-items-center box_time">
                <div class="icon_clock">
                    <img src="~@/assets/clock.png" alt="">
                </div>
                <div class="time-end">{{ $TestApp.getTimeCouter() | secondToMinute  }}</div>
            </div>
        </div>
        <b-container>
            <b-row class="header-test d-flex align-items-center mb-3 mt-4">
                <b-col sm="6" class="left_header">
                    <div class="box_title">{{ this.partTitle }}</div>
                </b-col>
                <b-col sm="6" class="d-flex justify-content-end right_header">
                    <div class="box_time d-flex align-items-center">
                        <div class="icon_clock">
                            <img src="~@/assets/clock.png" alt="">
                        </div>
                        <div class="time-end">{{ $TestApp.getTimeCouter() | secondToMinute }}</div>
                    </div>
                </b-col>
            </b-row>
            <div class="box_test">
                <div class="dotted">
                </div>
                <!-- không hiển thị yêu cầu của part đối với part_type == 2 (speaking) -->
                <div class="part-descreption" v-html="Questions.description" v-if="Questions.part_type != 2"></div>
                <div class="question-lock-list" v-if="Questions.part_type == 0">
                    <div class="question-block" v-for="(question) in Questions.questions" :key="question.id"  >
                        <type1 :content="question" v-if="question.content_type == 1 || question.content_type == 2">
                            <!-- <template v-slot:question-number>
                                <h2>Question {{ getQuestionNumber(Questions.questions, index) }}</h2>
                            </template> -->
                        </type1>
                        <type3 :content="question" v-if="question.content_type == 3">
                            <!-- <template v-slot:question-number>
                                <h2>Question {{ getQuestionNumber(Questions.questions, index) }}</h2>
                            </template> -->
                        </type3>
                        <div v-if="question.content_type == 5">
                            <b-container>
                                <b-row>
                                    <b-col lg="12">
                                        <div class="item_quesion">
                                            <div class="header_question">
                                                <div class="title_question ql-editor" style="" v-html="$TestApp.convertAssetsToBlob(question.content)"></div>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </div>
                    </div>
                </div>
            
                <div v-if="Questions.part_type == 1" class="part-writing pb-5">
                    <editor v-model="editorData" :resetContent="shouldResetContent" @resetshould="resetshouldContentNew()" />
                </div>
                <div v-if="Questions.part_type == 2" class="part-speaking">
                    <type4 :content="Questions" @end-part="$TestApp.nextPart()"></type4>
                </div>
                <!-- <type2/> -->
                <!-- <type4/> -->
            </div>
            <div class="d-flex justify-content-center button-pg1" v-if="Questions.part_type != 2">
                <b-button @click="nextPartAction" class="btn-custom" variant="success">Next</b-button>
            </div>
        </b-container>
    </div>
</template>
<script>

// mixins import
import page3Mixin from '@/plugins/TestPlugin/mixins/page3'

export default {
    mixins: [page3Mixin],
    components: {  },
    data() {
    return {
      navActive: false,
      editorData: '',
      shouldResetContent: false,
      isFirstSubmitted: false,
    };
  },
    mounted() {
        window.document.onscroll = () => {
            if(window.scrollY > 300){
                this.navActive = true;
                } else {
                this.navActive = false;
            }
        }

        this.$TestApp.countDownTimer()
    },
    methods: {
    clearEditorContent() {
      const textContent = this.editorData.replace(/<[^>]*>/g, '').trim();
      if (this.Questions.part_type == 1) {
        
        if (textContent.length <= 50) {
            this.$bvModal.show('check_character')
        }else{
            if (!this.isFirstSubmitted) {
                this.$TestApp.writing(this.editorData)
                this.isFirstSubmitted = true;
                this.shouldResetContent = true;
                localStorage.setItem(`${this.Questions.id}`, this.editorData);
                this.$TestApp.nextPart();
                
            } else {
                this.$TestApp.writing(this.editorData);
                this.isFirstSubmitted = false;
                localStorage.setItem(`${this.Questions.id}`, this.editorData);
                this.$TestApp.nextPart();
            }
        }
      } else {
        this.$TestApp.nextPart();
        
      }
      
    },
    resetshouldContentNew(value){
        this.shouldResetContent = value
    }
  },
    computed: {
    },
    created() {
    },
    watch: {
        editorData(newVal) {
        this.$TestApp.writing(newVal)
    }
    },
}
</script>
<style scoped>
/* .custom-quill-editor .ql-container {
  height: 300px; 
} */
    .time-box-sticky.sticky-nav {
        top: 0px;
    }

    .time-box-sticky {
        padding: 0px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fee138;
        padding-top: 10px;
        padding-bottom: 10px;
        position: fixed;
        top: -100px;
        width: 100%;
        z-index: 999;
        box-shadow: 0px 0px 20px 20px #0000001a;
        transition: all .2s;
    }
    
    .question-lock-list {
        margin-bottom: 30px;
    }
    .button-pg1 {
        top: -30px;
    }
    .box_test{
        /* height: 70vh; */
        background: #fff;
        border-radius: 20px;
        background: url(~@/assets/bg-box-test.png);
        background-repeat: repeat;
        /* overflow-y: scroll; */
        position: relative;
        padding-bottom: 50px !important;
        padding: 50px 40px;
        box-shadow: 0px 8px 0px #1990ef;
    }
    .dotted{
        position: absolute;
        width: 93%;
        top: -2px;
        background: url(~@/assets/dotted-box-test.png);
        background-repeat: repeat-x;
        height: 55px;
        left: 50%;
        transform: translateX(-50%);
    }
    .box_title, .box_time{
        background: #fee138;
        border: 1px solid #025dad;
        border-radius: 15px;
        padding: 5px 15px;
        width: fit-content;
        font-size: 28px;
        color: #025dad;
        font-weight: 700;
    }
    .icon_clock{
        width: 30px;
        height: 30px;
        margin-right: 10px;
        display: flex;
    }
    .header-test img, svg {
        vertical-align: unset;
    }
    /* custom scrollbar */
    ::-webkit-scrollbar {
        width: 20px;
    }

    ::-webkit-scrollbar-track {
        background-color: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #d6dee1;
        border-radius: 20px;
        border: 6px solid transparent;
        background-clip: content-box;
    }

    ::-webkit-scrollbar-thumb:hover {
        background-color: #a8bbbf;
    }
    .part-descreption {
        /* border: 1px solid #e0e0e099;
        border-radius: 5px;
        padding: 10px;
        margin-bottom: 40px;
        background-color: #fff; */
    }
    .header_question .title_question{
        /* margin-bottom: 20px; */
        /* color: #0057a7; */
        /* font-weight: 600; */
        padding: 0px;
        overflow: hidden;
    }
    @media only screen and (min-width: 1024px)  and (max-width: 1400px){
       /* .page3{
            height: auto;
        } */
    }

    @media only screen and (max-width: 768px){
        /* .page3{
            height: 100vh;
        } */
        .box_test{
            /* height: 70vh !important; */
        }
        .box_title, .box_time {
            font-size: 16px;
            height: 40px;
        }
        .box_test{
            /* height: 350px; */
        }
        .dotted {
            width: 80%;
        }
        .left_header{
            width: 70%;
        }
        .right_header{
            width: 30%;
        }
        .dotted{
            width: 90%;
            background-size: 28%;
        }
        .box_test{
            padding: 20px 15px;
        }
        .part-descreption{
            margin-bottom: 10px;
        }

        .item_answer{
            width: 100% !important;
        }
        .btn-custom.btn-success{
            font-style: 25px;
        }
    }

    @media only screen and (max-width: 400px){
        .box_title {
            width: 100%;
        }

        .left_header{
            width: 100%;
            margin-bottom: 10px;
        }
        .right_header{
            width: 100%;
            justify-content: start !important;
        }
    }
</style>
